import { createContext } from "react";
import { UserProfilesContextType } from "src/types/UserProfilesContext";

export const UserProfilesContext = createContext<UserProfilesContextType|null>(null);
